import { render, staticRenderFns } from "./SiteStatus.vue?vue&type=template&id=0bbf8b46&scoped=true"
import script from "./SiteStatus.vue?vue&type=script&lang=ts"
export * from "./SiteStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf8b46",
  null
  
)

export default component.exports